import ImgLight from "../../assets/img/FirstScreenImgLight.png";
import ImgDark from "../../assets/img/FirstScreenImgDark.png";
import crocodile from "../../assets/img/18.gif";
import { useSelector } from "react-redux";

export const FirstScreenImg = () => {
  const theme = useSelector((state) => state.app.theme);
  return (
    <div style={{ position: "relative" }}>
      {theme === "dark" ? (
        <img src={ImgDark} alt='FirstScreenImg' />
      ) : (
        <img src={ImgLight} alt='FirstScreenImg' />
      )}

      <img
        src={crocodile}
        style={{ position: "absolute", width: "15%", top: "36%", left: "60%" }}
        alt='men'
      />
    </div>
  );
};
